import { Link } from 'react-router';
import UROLogo from '../atoms/UROLogo';
import { Icon } from '../atoms/Icon';

const COLS = [
  { h: 'Product',    items: [['Zen', '/zen'], ['API', '#api'], ['Brand DNA', '#'], ['Studios', '/studios'], ['Pricing', '#pricing']] },
  { h: 'Developers', items: [['API Reference', '#api'], ['Documentation', '#api'], ['Status', '#'], ['Changelog', '#']] },
  { h: 'Company',    items: [['About', '#'], ['Blog', '#'], ['Discord', 'https://discord.gg/4b6S849Y2t'], ['Twitter/X', '#']] },
  { h: 'Legal',      items: [['Terms', '/terms'], ['Privacy', '/privacy'], ['Refund Policy', 'mailto:support@fluxuro.ai']] },
];

export default function Footer() {
  return (
    <footer style={{ paddingTop: 64, paddingBottom: 32, borderTop: '1px solid var(--border)', marginTop: 16 }}>
      <div className="container">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr 1fr 1fr', gap: 32 }}>
          <div>
            <UROLogo/>
            <p style={{ marginTop: 16, color: 'var(--text-3)', fontSize: 14, lineHeight: 1.6, maxWidth: 280 }}>
              Every AI model. One platform. Top up once. No subscriptions. No limits.
            </p>
          </div>
          {COLS.map(col => (
            <div key={col.h}>
              <div className="eyebrow" style={{ marginBottom: 14 }}>{col.h}</div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                {col.items.map(([label, href]) => (
                  <li key={label}>
                    <a href={href} style={{ color: 'var(--text-2)', textDecoration: 'none', fontSize: 14, transition: 'color .15s' }}
                       onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                       onMouseLeave={e => e.currentTarget.style.color = 'var(--text-2)'}>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="hr-gradient" style={{ marginTop: 48 }}/>
        <div className="row" style={{ marginTop: 22, justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ fontSize: 13, color: 'var(--text-3)' }}>© 2026 Flux URO · All rights reserved</div>
          <div className="row gap-3" style={{ color: 'var(--text-3)' }}>
            <a href="https://discord.gg/4b6S849Y2t" aria-label="Discord" style={{ color: 'inherit' }}><Icon.discord/></a>
            <a href="#" aria-label="Twitter / X" style={{ color: 'inherit' }}><Icon.twitter/></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
